import React, { Component } from 'react'
import SerializeForm from 'form-serialize'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

// React Material Web Components
import { Grid, GridCell } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Card } from 'rmwc/Card';
import { Snackbar } from 'rmwc/Snackbar';

import { Typography } from 'rmwc/Typography';
import centaLogo from '../assets/images/centa-logo-new.png';
import { Button } from 'rmwc/Button';
import StatusMessage from '../util/StatusMessage'


class ForgotPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      modal: false,
      snackbarIsOpen: false,
      validationErrors: {
        phoneNumberError: '',
        passwordError: '',
      },
      userInfo: {
        accessToken: '',
        client: '',
        uid: '',
        email: '',
        id: '',
        role: '',
        userName: '',
        image: '',
        phone: ''
      },
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.checkForErrors = this.checkForErrors.bind(this)
    
  }

  checkForErrors(values){
    return false;
  }

  handleSubmit(e) {
    e.preventDefault()
    const values = SerializeForm(e.target, { hash: true })
    // console.log(values)
    const err = this.checkForErrors(values)
    if (!err) {
      api
        .forgotPassword(values)
        .then((result) => {
          
          const { status, errors } = result
          if (status === 'error') {
            this.setState({ errorMsg: errors })
          }
          if (status === 'success') {
            this.setState({ errorMsg: '' })
            this.setState({snackbarIsOpen: !this.state.snackbarIsOpen})
          }
        })
        .catch((err) => {
          console.log('inside catch')
          this.setState({ errorMsg: 'Error in Forgot password link generation' })
        })
    }
  }


  render() {
    let Snackbarcomponent =(
          <Snackbar
            show={this.state.snackbarIsOpen}
            onHide={evt => this.setState({snackbarIsOpen: false})}
            message="A link to access your MyCENTA account has been sent to your email address. Please click on it to access your account."
      />
      )
    return (
      <div>
        <Grid className="login-card">
          <GridCell span="4" align="middle"></GridCell>
          <GridCell className="align-center" span="4">
            <form onSubmit={this.handleSubmit}>
              <Card style={{width: '21rem',padding: '25px'}}>
                <GridCell>
                  <div style={{padding: '0 1rem 1rem 1rem'}}>
                    <img src={centaLogo} alt="logo" />
                    <Typography use="title" tag="h3">Forgot  Username/Password</Typography>
                    <Typography
                      use="subheading1"
                      tag="h3"
                      theme="text-secondary-on-background"
                      style={{marginTop: '-1rem'}}
                    >
                    </Typography>
                  </div>
                </GridCell>
                {Snackbarcomponent}
                <GridCell>
                  <FormField style={{width: '100%'}}>
                    <div className="login_icon">
                      <TextFieldIcon use="lock_open"/>
                    </div>
                    <TextField fullwidth label="Email" autoComplete="off" name="email" className='user_name' />
                  </FormField>
                </GridCell>
                <GridCell className='submit-button'>
                  <FormField>
                    <Button raised>CONFIRM</Button>
                  </FormField>
                </GridCell>
              </Card>
            </form>
            <StatusMessage 
            error_msg = {this.state.errorMsg}
            />
          </GridCell>
          <GridCell span="4" align="middle"></GridCell>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)




// WEBPACK FOOTER //
// ./src/views/ForgotPassword.jsx